import { DocumentationComponent } from './documentation/documentation.component';
import { RiskprofileComponent } from './questionnaire/riskprofile/riskprofile.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuardian } from '@tech-services/loginGuardian.service';
import { MainComponent } from './main.component';
import { ProfilePortfolioComponent } from './profileportfolio/profileportfolio.component';
import { OpenpdfComponent } from './openpdf/openpdf.component';
import { InitialcontributionComponent } from './initialcontribution/initialcontribution.component';
import { StepComponent } from './step/step.component';
import { SettingsComponent } from './settings/settings.component';
import { PortfoliosComponent } from './portfolios/portfolios.component';
import { InvestmentserviceComponent } from './portfolios/investmentservice/investmentservice.component';
import { MainsettingsComponent } from './mainsettings/mainsettings.component';
import { SignComponent } from './sign/sign.component';
import { AppConfig } from '@tech-utils/app-config.service';
import { DomainEnum } from '@tech-utils/utils';

const routes: Routes = [
  {
    path: '',
    // canActivate: [LoginGuardian],
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: 'profileportfolio',
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: 'investmentservice',
        pathMatch: 'full',
      },
      {
        path: 'settings',
        canActivate: [LoginGuardian],
        component: SettingsComponent,
      },
      {
        path: 'accountsettings',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./accountsettings/accountsettings.module').then(
            (m) => m.AccountSettingsModule
          ),
      },
      {
        path: 'accountclose',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./account-close/account-close.module').then(
            (m) => m.AccountCloseModule
          ),
      },
      {
        path: 'portfolios',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./portfolios/portfolios.module').then(
            (m) => m.PortfoliosModule
          ),
      },
      {
        path: 'profileportfolio',
        canActivate: [LoginGuardian],
        component: ProfilePortfolioComponent,
      },
      {
        path: 'investmentservice',
        canActivate: [LoginGuardian],
        component: InvestmentserviceComponent,
      },
      {
        path: 'documents',
        canActivate: [LoginGuardian],
        component: DocumentationComponent,
        // component: DocumentationmanagerComponent,
      },
      {
        path: 'openpdf',
        canActivate: [LoginGuardian],
        component: OpenpdfComponent,
      },
      {
        path: 'step/:step',
        canActivate: [LoginGuardian],
        component: StepComponent,
      },
      {
        path: 'sign',
        canActivate: [LoginGuardian],
        component: SignComponent,
      },
      {
        path: 'operative',
        canActivate: [LoginGuardian],
        loadChildren: () => {
          const ba = AppConfig.settings.domain;
          switch (ba) {
            case DomainEnum.MSI:
              return import('./operative/operative2/operative2.module').then(
                (m) => m.Operative2Module
              );
            default:
              return import('./operative/operative1/operative1.module').then(
                (m) => m.Operative1Module
              );
          }
        },
      },
      {
        path: 'questionnaire',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./questionnaire/questionnaire.module').then(
            (m) => m.QuestionnaireModule
          ),
      },
      {
        path: 'riskprofile',
        canActivate: [LoginGuardian],
        component: RiskprofileComponent,
        /*children: [
          { path: 'questionnaire', component: QuestionnaireComponent, canActivateChild: [LoginGuardian]},
        ],*/
      },
      {
        path: 'notifications',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./notifications/notification.module').then(
            (m) => m.NotificationModule
          ),
      },
      {
        path: 'chat',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./chat/chat.module').then((m) => m.ChatModule),
      },

      {
        path: 'activities',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./activities/activities.module').then(
            (m) => m.ActivitiesModule
          ),
      },
      {
        path: 'initialcontribution',
        canActivate: [LoginGuardian],
        component: InitialcontributionComponent,
      },
      {
        path: 'financialplanning',
        loadChildren: () =>
          import('./financialplaning/financialplaning.module').then(
            (m) => m.financialplaningModule
          ),
      },
      {
        path: 'completedata',
        loadChildren: () =>
          import('./completedata/completedata.module').then(
            (m) => m.CompletedataModule
          ),
      },
      {
        path: 'editclientdata',
        loadChildren: () =>
          import('./editclientdata/editclientdata.module').then(
            (m) => m.EditclientdataModule
          ),
      },
      {
        path: 'datacollection',
        loadChildren: () =>
          import('./datacollection/datacollection.module').then(
            (m) => m.DatacollectionModule
          ),
      },
      {
        path: 'datacollectiond/:view/:isEdit',
        loadChildren: () =>
          import('./datacollectiondinamic/datacollectiondinamic.module').then(
            (m) => m.DatacollectionDinamicModule
          ),
      },
      {
        path: 'datacollectiond/:view',
        loadChildren: () =>
          import('./datacollectiondinamic/datacollectiondinamic.module').then(
            (m) => m.DatacollectionDinamicModule
          ),
      },
      {
        path: 'mainsettings',
        canActivate: [LoginGuardian],
        component: MainsettingsComponent,
      },
      {
        path: 'modelportfoliothemes',
        loadChildren: () =>
          import('./modelportfoliothemes/modelportfoliothemes.module').then(
            (m) => m.ModelportfoliothemesModule
          ),
      },
      {
        path: 'laboratory',
        canActivate: [LoginGuardian],
        loadChildren: () =>
          import('./laboratory/laboratory.module').then(
            (m) => m.LaboratoryModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
